// import React from "react";
// import VehicleRange from "./VehicleRange";
// import v1 from "../../videos2/Banner2.mp4";
// import FindVehicle from "./Filtervehicles";
// import { motion } from "framer-motion";
// import AboutJAPL from "./Aboutpage";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

// const bannerImages = [
//   "https://trucks.tatamotors.com/assets/trucks/files/cat-banner/2024-11/tata-signa-bnr_0.jpg?VersionId=wEhrhoIffDmgFNva4GnwRKYa6lqZObBS",
//   "https://res.cloudinary.com/dk10z0h1f/image/upload/v1742362131/tata-prima-bnr_ke6p2e.jpg",
//   "https://res.cloudinary.com/dk10z0h1f/image/upload/v1742362131/tata-ultra-bnr_nwr2ad.jpg"
// ];

// const Home = () => {
//   return (
//     <div className="relative overflow-hidden text-justify">
//       {/* Hero Video Section - Full viewport on all devices */}
//       <section className="relative w-full h-screen min-h-[600px]">
//         <div className="absolute inset-0 w-full h-full flex items-center justify-center overflow-hidden">
//           <video
//             className="min-w-full min-h-full w-auto h-auto absolute object-cover"
//             autoPlay
//             loop
//             muted
//             playsInline
//           >
//             <source src={v1} type="video/mp4" />
//             Your browser does not support the video tag.
//           </video>
          
//           {/* Optional overlay content */}
//           <div className="relative z-10 h-full w-full flex items-center justify-center">
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-center text-white px-4"
//             >
//               {/* Add your content here if needed */}
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Rest of your content remains the same */}
//       <div className="space-y-12 md:space-y-16 lg:space-y-24 py-8 md:py-12 lg:py-16 xl:py-24">
//         {/* Vehicle Range Section */}
//         <section className="px-4 sm:px-6 lg:px-8 xl:px-12">
//           <motion.div
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             viewport={{ once: true }}
//           >
//             <VehicleRange />
//           </motion.div>
//         </section>

//         {/* Vehicle Finder Section */}
//         <section className="px-4 sm:px-6 lg:px-8 xl:px-12">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//           >
//             <FindVehicle />
//           </motion.div>
//         </section>

//         {/* About Section */}
//         <section className="px-4 sm:px-6 lg:px-8 xl:px-12">
//           <motion.div
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             viewport={{ once: true }}
//             className="max-w-7xl mx-auto"
//           >
//             <AboutJAPL />
//           </motion.div>
//         </section>
//       </div>
//        {/* Featured Models Slider */}
//        <section className="px-0 sm:px-4 lg:px-0">
//           <motion.div
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             viewport={{ once: true }}
//             className="relative"
//           >
//             <Swiper
//               modules={[Navigation, Pagination, Autoplay]}
//               spaceBetween={10}
//               slidesPerView={1}
//               navigation={{
//                 nextEl: ".swiper-button-next",
//                 prevEl: ".swiper-button-prev",
//               }}
//               pagination={{
//                 clickable: true,
//                 el: ".swiper-pagination",
//                 type: "bullets",
//               }}
//               autoplay={{ delay: 5000, disableOnInteraction: false }}
//               loop={true}
//               className="h-auto"
//             >
//               {bannerImages.map((src, index) => (
//                 <SwiperSlide key={index}>
//                   <div className="relative h-[40vh] sm:h-[50vh] md:h-[60vh] lg:h-[70vh] w-full">
//                     <img
//                       src={src}
//                       alt={`Banner ${index + 1}`}
//                       className="w-full h-full object-cover"
//                     />
//                     <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
//                       <div className="text-center text-white space-y-2 sm:space-y-4 px-4">
//                         <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold">New Generation Models</h3>
//                         <p className="text-sm sm:text-base md:text-lg lg:text-xl">Experience premium performance</p>
//                       </div>
//                     </div>
//                   </div>
//                 </SwiperSlide>
//               ))}
//             </Swiper>
            
//             <div className="swiper-button-next !text-white !w-8 !h-8 sm:!w-12 sm:!h-12 md:!w-16 md:!h-16 after:text-sm sm:after:text-lg md:after:text-2xl" />
//             <div className="swiper-button-prev !text-white !w-8 !h-8 sm:!w-12 sm:!h-12 md:!w-16 md:!h-16 after:text-sm sm:after:text-lg md:after:text-2xl" />
//             <div className="swiper-pagination !bottom-4 sm:!bottom-6 md:!bottom-8" />
//           </motion.div>
//         </section>
//     </div>
//   );
// };

// export default Home;
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import VehicleRange from "./VehicleRange";
import v1 from "../../videos2/Banner2.mp4";
import FindVehicle from "./Filtervehicles";
import { motion } from "framer-motion";
import AboutJAPL from "./Aboutpage";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { FiX, FiChevronRight, FiVolume2 } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const bannerImages = [
  "https://trucks.tatamotors.com/assets/trucks/files/cat-banner/2024-11/tata-signa-bnr_0.jpg?VersionId=wEhrhoIffDmgFNva4GnwRKYa6lqZObBS",
  "https://res.cloudinary.com/dk10z0h1f/image/upload/v1742362131/tata-prima-bnr_ke6p2e.jpg",
  "https://res.cloudinary.com/dk10z0h1f/image/upload/v1742362131/tata-ultra-bnr_nwr2ad.jpg",
];

const API_BASE_URL = (process.env.NODE_ENV === 'production' ? "https://japl-backend-v2jm.onrender.com/api" : 'http://localhost:5000/api');

// change these to your actual values
const WHATSAPP_NUMBER = "916364861939"; // without '+'
const BLOG_LIST_URL = "/blogs"; // your blog listing route

const Home = () => {
  const [showPopup, setShowPopup] = useState(true);
  const [showBadge, setShowBadge] = useState(false);
  const [latestBlogTitle, setLatestBlogTitle] = useState("");
  const [blogLoading, setBlogLoading] = useState(true);

  // Fetch latest blog title
  useEffect(() => {
    let isMounted = true;

    async function fetchLatestBlog() {
      try {
        const res = await fetch(`${API_BASE_URL}/blogs`);
        if (!res.ok) throw new Error("Failed to load blogs");
        const data = await res.json();

        if (!isMounted) return;

        if (Array.isArray(data) && data.length > 0) {
          setLatestBlogTitle(data[0].title || "New blog available");
        } else {
          setLatestBlogTitle("New blog available");
        }
      } catch {
        if (!isMounted) return;
        setLatestBlogTitle("New blog available");
      } finally {
        if (isMounted) setBlogLoading(false);
      }
    }

    fetchLatestBlog();
    return () => {
      isMounted = false;
    };
  }, []);

  // Auto-hide popup after 5 seconds (once it is visible)
  useEffect(() => {
    if (!showPopup) return;
    const timer = setTimeout(() => {
      setShowPopup(false);
      setShowBadge(true);
    }, 5000); // 5 seconds
    return () => clearTimeout(timer);
  }, [showPopup]);

  const handleClosePopup = () => {
    setShowPopup(false);
    setShowBadge(true);
  };

  const handleOpenPopup = () => {
    setShowPopup(true);
    setShowBadge(false);
  };

  const handleWhatsappClick = () => {
    const msg = encodeURIComponent(
      "Hi, I just visited your website. I’d like to know more."
    );
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`, "_blank");
  };

  return (
    <div className="relative overflow-hidden text-justify">
      {/* Hero Video Section - Full viewport on all devices */}
      <section className="relative w-full h-screen min-h-[600px]">
        <div className="absolute inset-0 w-full h-full flex items-center justify-center overflow-hidden">
          <video
            className="min-w-full min-h-full w-auto h-auto absolute object-cover"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={v1} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* Optional overlay content */}
          <div className="relative z-10 h-full w-full flex items-center justify-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center text-white px-4"
            >
              {/* Add your content here if needed */}
            </motion.div>
          </div>
        </div>
      </section>

      {/* Rest of your content */}
      <div className="space-y-12 md:space-y-16 lg:space-y-24 py-8 md:py-12 lg:py-16 xl:py-24">
        {/* Vehicle Range Section */}
        <section className="px-4 sm:px-6 lg:px-8 xl:px-12">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <VehicleRange />
          </motion.div>
        </section>

        {/* Vehicle Finder Section */}
        <section className="px-4 sm:px-6 lg:px-8 xl:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <FindVehicle />
          </motion.div>
        </section>

        {/* About Section */}
        <section className="px-4 sm:px-6 lg:px-8 xl:px-12">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="max-w-7xl mx-auto"
          >
            <AboutJAPL />
          </motion.div>
        </section>
      </div>

      {/* Featured Models Slider */}
      <section className="px-0 sm:px-4 lg:px-0">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="relative"
        >
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={10}
            slidesPerView={1}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            pagination={{
              clickable: true,
              el: ".swiper-pagination",
              type: "bullets",
            }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            loop={true}
            className="h-auto"
          >
            {bannerImages.map((src, index) => (
              <SwiperSlide key={index}>
                <div className="relative h-[40vh] sm:h-[50vh] md:h-[60vh] lg:h-[70vh] w-full">
                  <img
                    src={src}
                    alt={`Banner ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                    <div className="text-center text-white space-y-2 sm:space-y-4 px-4">
                      <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold">
                        New Generation Models
                      </h3>
                      <p className="text-sm sm:text-base md:text-lg lg:text-xl">
                        Experience premium performance
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="swiper-button-next !text-white !w-8 !h-8 sm:!w-12 sm:!h-12 md:!w-16 md:!h-16 after:text-sm sm:after:text-lg md:after:text-2xl" />
          <div className="swiper-button-prev !text-white !w-8 !h-8 sm:!w-12 sm:!h-12 md:!w-16 md:!h-16 after:text-sm sm:after:text-lg md:after:text-2xl" />
          <div className="swiper-pagination !bottom-4 sm:!bottom-6 md:!bottom-8" />
        </motion.div>
      </section>

      {/* BLOG POPUP - BOTTOM RIGHT */}
      {/* BLOG POPUP - RESPONSIVE POSITIONING */}
{showPopup && (
  <div className="fixed z-50 w-full sm:max-w-sm bottom-6 left-1/2 sm:right-6 sm:left-auto -translate-x-1/2 sm:translate-x-0 px-4 sm:px-0">
    <div className="bg-white shadow-2xl rounded-2xl border border-gray-200 overflow-hidden max-w-full sm:max-w-sm w-full mx-auto sm:mx-0">
      <div className="flex items-start p-4 gap-2">
        <div className="flex-1 space-y-1 min-w-0">
          {/* Company name */}
          <p className="text-sm font-bold tracking-wide text-blue-800 uppercase">
            Janatha Automobiles Private Limited
          </p>

          {/* Latest posts line with icon */}
          <div className="flex items-center text-[11px] font-semibold text-black uppercase tracking-wide">
            <span>Latest Posts</span>
             <FiVolume2 className="ml-1.5 text-red-500" />
          </div>

          {/* Scrolling blog title */}
          <div className="w-full overflow-hidden">
            <div className="whitespace-nowrap animate-[marquee_10s_linear_infinite] text-sm text-gray-900 font-medium">
              {blogLoading
                ? "Loading latest blog..."
                : latestBlogTitle || "New blog available"}
            </div>
          </div>

          {/* Description */}
          <p className="mt-1 text-xs text-gray-600 pb-2 line-clamp-2">
            Check out our latest blog post for insights, updates and offers curated for you.
          </p>

          {/* Buttons */}
          <div className="mt-2 flex flex-wrap items-center gap-2 sm:gap-3">
            <Link to={BLOG_LIST_URL}>
              <button className="inline-flex items-center px-3 py-1.5 text-xs font-semibold bg-black text-white rounded-lg hover:bg-blue-700 transition whitespace-nowrap">
                Read blog
                <FiChevronRight className="ml-1" />
              </button>
            </Link>

            <button
              type="button"
              onClick={handleWhatsappClick}
              className="inline-flex items-center px-3 py-1.5 text-xs font-semibold bg-green-500 text-white rounded-full hover:bg-green-600 transition whitespace-nowrap"
            >
              <FaWhatsapp className="mr-1" />
              WhatsApp
            </button>
          </div>
        </div>

        <button
          type="button"
          onClick={handleClosePopup}
          className="ml-3 text-gray-400 hover:text-gray-600 transition flex-shrink-0"
          aria-label="Close"
        >
          <FiX className="w-5 h-5" />
        </button>
      </div>

      <div className="bg-gray-50 px-4 pb-2 text-[10px] text-gray-500 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-1 sm:gap-0">
        <span>Stay updated with our latest posts.</span>
        <span className="text-blue-500 font-medium">JAPL Blogs</span>
      </div>
    </div>
  </div>
)}


      {/* COLLAPSED BADGE ON RIGHT EDGE */}
      {showBadge && (
        <div className="fixed bottom-6 right-4 z-30 flex flex-col items-end space-y-2">
          <button
            type="button"
            onClick={handleOpenPopup}
            className="bg-white border border-gray-200 shadow-lg rounded-full pl-4 pr-2 py-2 flex items-center text-sm text-gray-800 hover:shadow-xl transition"
          >
            <span className="font-semibold mr-2">New Blog</span>
            <FiChevronRight className="w-4 h-4 text-blue-600" />
          </button>

          <button
            type="button"
            onClick={handleWhatsappClick}
            className="w-12 h-12 rounded-full bg-green-500 shadow-xl flex items-center justify-center text-white hover:bg-green-600 transition"
            aria-label="Chat on WhatsApp"
          >
            <FaWhatsapp className="w-6 h-6" />
          </button>
        </div>
      )}

      {/* Tailwind keyframes for marquee (if not already in your global CSS) */}
      {/* 
        Ensure you have this in your global CSS or Tailwind config:
        @keyframes marquee {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
      */}
    </div>
  );
};

export default Home;
